<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CompanyTypeModal from '@/components/admin/company-type-modal.vue';
import api from '@/helpers/api-rest/api.js';


export default {
  page: {
    title: "Tipos de compañía",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, CompanyTypeModal},
  data() {
    return {
      tableData: [],
      title: "Tipos de compañía",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        { key: "id", sortable: true, label: "ID" },
        { key: "name", sortable: true, label: "Nombre" },
        { key: "category", sortable: true, label: "Categoría" },
        { key: "icon", sortable: true, label: "Icono" },
        { key: "action", tdClass:"custom-table-action", sortable: false, label: "" }
      ],
      showTypeModal: false,
      editMode: false,
      typeEdit: undefined,
      switchStatus: false,
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    }
  },
  methods: {
    loadDataFromApi(){
      const apiEndpoint = `/api/v1/company-types`;
      api.get({url:apiEndpoint})
        .then(response => {
          this.tableData = response.data;
          this.tableData.forEach(company_type => {
            company_type.switchStatus = company_type.status === true;
          });

        })
        .catch(error => {
          console.error("Error loading data:", error);
        });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    success(company_type) {
      console.log(company_type);
      this.loadDataFromApi();
      // if (this.typeEdit) {
      //   this.typeEdit = company_type;
      // }else{
      //   this.tableData.push(company_type);
      //   company_type.switchStatus = company_type.status === true;
      // }


    },
    addCompanyType() {
      this.typeEdit = undefined;
    },
    editCompanyType(company_type) {
      this.typeEdit = company_type;
    },
    toggleStatus(company_type){
      //const apiHost = process.env.VUE_APP_API_HOST;
      const apiEndpoint = `/api/v1/company-types/change-status/${company_type.id}?_method=PATCH`;
      api.post({url:apiEndpoint})
      //axios.post(apiEndpoint)
        .then(response => {
            company_type.status = response.data.status;
            company_type.switchStatus = company_type.status === true;
        })
        .catch(error => {
          console.error("Error loading data:", error);
        });
    },
    handleSwitchInput(company_type) {
      this.toggleStatus(company_type);
    }
  },
  mounted() {
    this.loadDataFromApi();
    // Set the initial number of items
    this.totalRows = this.tableData.length;
    //console.log(this.fields);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title">
      <template v-slot:header-button>
        <button v-b-modal.ModalCompanyType @click="addCompanyType()" class="btn btn-primary">
          <i class="fa fa-plus"></i> Añadir Tipo
        </button>
      </template>
    </PageHeader>
    <CompanyTypeModal :show-type-modal="showTypeModal" :company_type="typeEdit" @success="success" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="card-title">Data Table</h4> -->
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;registros
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    <!-- Buscar: -->
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Buscar..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
              <template v-slot:cell(icon)="row">
                <div>
                  <img :src="row.item.icon_url" height="35px" width="35px"/>
                </div>
              </template>
              <template v-slot:cell(action)="row">
                <div>
                  <a href="javascript:void(0);" class="mr-3 text-primary" v-b-modal.ModalCompanyType title="Edit" @click="editCompanyType(row.item)">
                    <i class="mdi mdi-pencil font-size-18"></i>
                  </a>
                  <b-form-checkbox
                      v-model="row.item.status"
                      switch class="mb-1"
                      value="1"
                      @change="handleSwitchInput(row.item)"
                    ></b-form-checkbox>
                </div>
              </template>
            </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>